// Stripe Checkout product catalogue for the order form.
export const STRIPE_PRODUCTS = [
  {
    id: "redoc-single",
    name: "Redoc AML & KYC – enanvändarversion",
    price: "2 800:-/år exkl moms",
    description: "För enskild användare på byrån.",
    stripeUrl: "https://buy.stripe.com/8x24gz97R3TZ5fR6Wz9EI0w",
  },
  {
    id: "redoc-multi",
    name: "Redoc AML & KYC – fleranvändarversion",
    price: "Från 5 320:-/år exkl moms",
    description: "För flera användare/kontor på byrån.",
    stripeUrl: "https://buy.stripe.com/7sYeVd5VFeyD6jV6Wz9EI0A",
  },
  {
    id: "redoc-templates",
    name:
      "Installation av exempelmallar i Redoc AML & KYC för riskanalys",
    price: "2 980:- exkl moms",
    description:
      "För tjänsterna löpande redovisning, löner, bokslut, inkomstdeklaration och sammantagen riskbedömning.",
    stripeUrl: "https://buy.stripe.com/3csdSs5771RefRe00q",
  },
  {
    id: "redoc-routines",
    name:
      "Byråns rutiner avs. åtgärder enligt Penningtvättlagen",
    price: "3 980:- exkl moms",
    description:
      "Anpassad mall/manual för användning tillsammans med Redoc AML & KYC.",
    stripeUrl: "https://buy.stripe.com/4gMaEXgAj4Y323FbcP9EI0D",
  },
];
